module.exports = __webpack_public_path__ + "img/11.ec32b5d2.jpg";